import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import 'hammerjs';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.module';
import { bootstrapApplication } from '@angular/platform-browser';
import { registerLicense } from '@syncfusion/ej2-base';

if (environment.production == true) {
	enableProdMode();
	console.log = () => {}; // turn off for production
}

document.title = environment.company;

// Register Syncfusion license
if (environment.syncfusionLicense) {
	registerLicense(environment.syncfusionLicense);
}

function bootstrap() {
	bootstrapApplication(AppComponent, appConfig).catch(err => {
		console.error(err);
	});
}

bootstrap();
